<template>
    <div class="row">
        <div class="col-md-3 custom-sidebar py-5">
            <h4 class="side-navbar-title mb-4">Settings</h4>

            <div class="panel-group side-navbar">
                <template v-for="entry in menu" >
                    <a :key="entry.key || entry.group" v-if="!entry.group && entry.show" href="#" target="_self" class="nav-link"
                        :class="{ active: currentTabKey === entry.key }"
                        @click.stop="open_item_selected(entry.key)">{{ entry.label }}</a>

                    <div v-else-if="entry.group && entry.show" class="panel panel-default">
                        <div class="panel-heading">
                            <h4 class="panel-title mb-0">
                                <a :class="{ 'collapsed': !isInGroup(entry.group) }"
                                    data-toggle="collapse" :href="'#collapse-' + entry.group">{{ entry.label }}</a>
                            </h4>
                        </div>
                        <div :id="'collapse-' + entry.group" class="panel-collapse collapse"
                            :class="{ 'show': isInGroup(entry.group) }">
                            <ul class="list-group">
                                <li v-for="item in entry.items.filter(i => i.show)" :key="item.key"
                                    class="list-group-item nav-item">
                                    <a href="#" class="dropdown-item"
                                        :class="{ active: currentTabKey === item.key }"
                                        @click.stop="open_item_selected(item.key)">{{ item.label }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <div class="col-md-9 pr-0">

            <template v-if="currentTabKey === 'approval_loan'">
                <h4 class="atlhr-dashboard-title mt-10 px-4 mb-0">Approval Settings<span>
                        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / Approval Settings / PF Loan</span>
                </h4>
            </template>
            <template v-else-if="currentTabKey === 'approval_investment'">
                <h4 class="atlhr-dashboard-title mt-10 px-4 mb-0">Approval Settings<span>
                        <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / Approval Settings / PF Investment</span>
                </h4>
            </template>

            <div class="col-md-12 pb-4 pr-0">
                <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
                <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{ warningmsg }}</b-alert>
                <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{ dangermsg }}</b-alert>

                <div class="" v-if="this.tmp_flg">
                    <div class="pt-1 settings-panel company-info-container custom-side">

                        <b-tabs pills content-class="trz-wizard-content" nav-class="bg-white"
                            nav-wrapper-class="col-md-9 card no-shadow custom-margin custom-tab-nav ml-auto pl-0 d-none"
                            :value="tabIndex"
                            @input="onTabInput">

                            <!-- Special-cased: overview (needs event listener, not generic props) -->
                            <b-tab v-if="isVisible('overview')">
                                <template v-slot:title>Overview</template>
                                <div class="clearfix">
                                    <company-overview :check_ce="1" :ce_flg="this.ce" v-on:childToParent="getOverviewFlg"></company-overview>
                                </div>
                            </b-tab>

                            <!-- Special-cased: holidays (component depends on client-only supper_user) -->
                            <b-tab v-if="isVisible('holidays')" lazy>
                                <template v-slot:title>Holidays</template>
                                <div class="clearfix">
                                    <holidays-managed-by-system-user :pageurl="this.$api_url" v-if="supper_user == true"></holidays-managed-by-system-user>
                                    <holidays :pageurl="this.$api_url" v-else></holidays>
                                </div>
                            </b-tab>

                            <!-- Special-cased: attendance (large inline form block, not a registered component) -->
                            <b-tab v-if="isVisible('attendance')" lazy>
                                <template v-slot:title>Attendance</template>
                                <div class="clearfix">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave &amp; Attendance<span>
                                            <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> /
                                            Settings / Leave &amp; Attendance / Attendance</span>
                                    </h4>
                                    <div class="row no-margin mt-4">
                                        <div class="ibox col-md-12 mb-0 px-5">
                                            <div class="ibox no-shadow border-2 mt-5 gray-border leave-attendance-legends">
                                                <div class="clearfix mt-2 mx-auto px-5 py-2">
                                                    <b-form-group label="Click on the day to select/deselect weekly holidays">
                                                        <b-form-checkbox-group class="leave-attendance-btns w-100"
                                                            v-model="week_holidays" :options="options" buttons
                                                            button-variant="outline-secondary">
                                                        </b-form-checkbox-group>
                                                    </b-form-group>
                                                </div>
                                            </div>

                                            <div class="ibox no-shadow border-2 mt-5 gray-border leave-attendance-contents">
                                                <div class="row py-5 no-margin">
                                                    <div class="col-sm-6">
                                                        <div class="row custom-color-inputs no-margin px-5 align-items-center h-100">
                                                            <div class="col-12 font-medium text-center px-2 pb-5" style="font-size: 18px; color: rgb(116, 116, 116);">
                                                                Color Code Selector
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <b-form-group id="weekend_color_code-group">
                                                                    <b-form-input id="weekend_color_code" name="weekend_color_code" v-model="weekend_color_code" type="color"></b-form-input>
                                                                    <label for="weekend_color_code" class="d-block px-3 pt-2 text-dark" style="font-size: 17px;">Weekend Color Code</label>
                                                                    <span class="d-block px-3 text-secondary font-medium pb-3" style="font-size: 15px;">{{ weekend_color_code }}</span>
                                                                </b-form-group>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <b-form-group id="holiday_color_code-group">
                                                                    <b-form-input id="holiday_color_code" name="holiday_color_code" v-model="holiday_color_code" type="color"></b-form-input>
                                                                    <label for="holiday_color_code" class="d-block px-3 pt-2 text-dark" style="font-size: 17px;">Holiday Color </br> Code</label>
                                                                    <span class="d-block px-3 text-secondary font-medium pb-3" style="font-size: 15px;">{{ holiday_color_code }}</span>
                                                                </b-form-group>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-6 px-5 border-left d-flex flex-column justify-content-center">
                                                        <div class="clock-in-block">
                                                            <b-form-group id="entry_time-group" class="clock-in-out-group">
                                                                <label for="entry_time" class="clock-in-out-label">Clock In <span class="text-dark ml-1"> Time</span></label>
                                                                <b-form-timepicker id="entry_time" name="entry_time" v-model="entry_time" now-button reset-button locale="en"></b-form-timepicker>
                                                            </b-form-group>

                                                            <div class="row mb-5">
                                                                <b-form-group id="allow_grace_time_late_check_in-group" label-for="allow_grace_time_late_check_in" class="col-md-6 mb-0">
                                                                    <b-form-checkbox id="allow_grace_time_late_check_in" v-model="allow_grace_time_late_check_in" name="allow_grace_time_late_check_in" value="1">
                                                                        Grace Time (late check in)
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                                <b-input-group id="grace_time_late_check_in-group" class="col-md-6 radius-left-0 gray-input" append="Minutes">
                                                                    <b-form-input id="grace_time_late_check_in" name="grace_time_late_check_in" type="text" v-model="grace_time_late_check_in"></b-form-input>
                                                                </b-input-group>
                                                            </div>
                                                        </div>

                                                        <div class="clock-out-block">
                                                            <b-form-group id="exit_time-group" class="clock-in-out-group">
                                                                <label for="exit_time" class="clock-in-out-label">Clock Out <span class="text-dark ml-1"> Time</span></label>
                                                                <b-form-timepicker id="exit_time" name="exit_time" v-model="exit_time" now-button reset-button locale="en"></b-form-timepicker>
                                                            </b-form-group>
                                                            <div class="row">
                                                                <b-form-group id="allow_grace_time_early_checkout-group" label-for="allow_grace_time_early_checkout" class="col-md-6 mb-0">
                                                                    <b-form-checkbox id="allow_grace_time_early_checkout" v-model="allow_grace_time_early_checkout" name="allow_grace_time_early_checkout" value="1">
                                                                        Grace Time (early checkout)
                                                                    </b-form-checkbox>
                                                                </b-form-group>
                                                                <b-input-group id="grace_time_early_checkout-group" label="" label-for="grace_time_early_checkout" class="col-md-6 radius-left-0 gray-input" append="Minutes">
                                                                    <b-form-input id="grace_time_early_checkout" name="grace_time_early_checkout" type="text" v-model="grace_time_early_checkout"></b-form-input>
                                                                </b-input-group>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 px-5 border-left d-flex flex-column justify-content-center pt-5">
                                                        <div class="d-flex justify-content-center">
                                                            <b-form-group id="ess_punch-group" label-for="ess_punch">
                                                                <b-form-checkbox id="ess_punch" v-model="ess_punch" name="ess_punch" value="1">
                                                                    Allow ESS Punch In/Out
                                                                </b-form-checkbox>
                                                            </b-form-group>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 px-5 border-left d-flex flex-column justify-content-center">
                                                        <div class="d-flex justify-content-center">
                                                            <b-form-group id="attendance_flexibility-group" label-for="attendance_flexibility">
                                                                <b-form-checkbox id="attendance_flexibility" v-model="attendance_flexibility" name="attendance_flexibility" :value="1" :unchecked-value="0">
                                                                    Enable Attendance Flexibility
                                                                </b-form-checkbox>
                                                            </b-form-group>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 px-5 border-left d-flex flex-column justify-content-center">
                                                        <div v-if="attendance_flexibility == 1" class="row">
                                                            <div class="col-sm-12 row mt-4">
                                                                <div class="col-sm-6">
                                                                    <b-form-group id="office_start_time-group" label="Office Start Time" label-for="office_start_time">
                                                                        <b-form-timepicker id="office_start_time" name="office_start_time" v-model="office_start_time" :labelCloseButton="'Save'" reset-button locale="en"></b-form-timepicker>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <b-form-group id="office_end_time-group" label="Office End Time" label-for="office_end_time">
                                                                        <b-form-timepicker id="office_end_time" name="office_end_time" :labelCloseButton="'Save'" v-model="office_end_time" reset-button locale="en"></b-form-timepicker>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="btn-wrapper text-center py-5">
                                                <b-button variant="primary" @click="saveSettings()" class="">Apply Changes</b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <!-- Dynamic: everything else is API-driven -->
                            <b-tab v-for="tab in dynamicTabs" :key="tab.key" lazy>
                                <template v-slot:title>{{ tab.label }}</template>
                                <div class="clearfix">
                                    <component
                                        :is="tab.component"
                                        v-bind="resolveProps(tab)"
                                        v-on:childToParent="handleChildToParent(tab.key, $event)">
                                    </component>
                                </div>
                            </b-tab>

                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.section-title { background: #EEEEEE; }
.company-info-container .col-auto ul.nav-pills {
    border: none !important; height: auto !important; border-radius: 0 !important;
    box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.3) !important; height: 100% !important;
}
.list-tables { border-collapse: separate; border-spacing: 0 5px; }
.list-tables .list-columns { background: #E8EAF6; }
.list-tables td { border: none !important; }
.dark-mode-enabled .company-info-container .col-auto .nav-pills .nav-link {
    background-color: #293557; border-color: #1B233A; border-width: 2px;
}
.company-info-container .col-auto .nav-pills .nav-link {
    font-size: 15px; padding: 10px 31px; border-radius: 0.25rem !important;
}
.dark-mode-enabled .company-info-container .col-auto .nav-pills .nav-link.active,
.dark-mode-enabled .company-info-container .col-auto .nav-pills .show>.nav-link,
.dark-mode-enabled .company-info-container .col-auto .nav-pills .nav-link:hover {
    background-color: #5A8DEE; border-color: #5A8DEE !important; border-width: 0 !important;
}
.nav-pills .nav-link { text-transform: capitalize; }
</style>

<script>
/**
 * Groups used by isInGroup() when the group's items came back from the API menu.
 * 'overview' and 'attendance' have no group entry since they're standalone/special-cased.
 */
export default {

    mounted() {
        this.getAcl();
    },

    props: ['pf_enabled'],

    components: {},

    data() {
        return {
            cu: window.location.href,

            service_book_settings_available: true,

            ce: false,
            tmp_flg: false,
            pageurl: this.$api_url,
            pgurl: this.$api_url,
            completion: 0,

            jp_flg: 0,
            c_flg: 0,

            overview_flg: 0,
            taxinfo_flg: 0,
            departments_flg: 0,
            jobpositions_flg: 0,
            branches_flg: 0,

            logophoto: null,
            logosrc: null,
            isHovered: false,

            successmsg: false,
            warningmsg: false,
            dangermsg: false,

            addons: [],

            // ── Menu / tab state ─────────────────────────────────────────
            menu: [],                 // fetched from /settings-menu
            currentTabKey: 'overview',
            tabIndex: 0,
            // ──────────────────────────────────────────────────────────────

            supper_user: false,

            week_holidays: [6],
            options: [
                { text: 'Friday',    value: '5' },
                { text: 'Saturday',  value: '6' },
                { text: 'Sunday',    value: '0' },
                { text: 'Monday',    value: '1' },
                { text: 'Tuesday',   value: '2' },
                { text: 'Wednesday', value: '3' },
                { text: 'Thursday',  value: '4' },
            ],
            weekend_color_code: '#aaaaaa',
            holiday_color_code: '#aaaaaa',
            connect_to_payroll_calculation: false,
            entry_time: null,
            allow_grace_time_late_check_in: false,
            grace_time_late_check_in: 0,
            adjust_salary_late_check_in: false,
            days_salary_for_late_check_in: 0.1,
            days_late_check_in: 0,
            exit_time: null,
            allow_grace_time_early_checkout: false,
            grace_time_early_checkout: 0,
            adjust_salary_early_checkout: false,
            days_salary_for_early_checkout: 0.1,
            days_early_checkout: 0,
            allow_overtime: false,
            days_salary_for_overtime: 0,
            search: '',
            blankmsg: '',
            length_options: [
                { value: 20,  text: "20"  },
                { value: 50,  text: "50"  },
                { value: 100, text: "100" },
            ],
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            ess_punch: 0,
            attendance_flexibility: 0,
            office_start_time: null,
            office_end_time: null,

            roster: 0,
            roster_access_settings: {},
        };
    },

    computed: {
        /**
         * Flattened list of every item in the fetched menu, in declared order,
         * whether it lives at the top level or inside a group.
         */
        flatMenuItems() {
            const flat = [];
            for (const entry of this.menu) {
                if (entry.group) {
                    if (Array.isArray(entry.items)) flat.push(...entry.items);
                } else {
                    flat.push(entry);
                }
            }
            return flat;
        },

        /**
         * Items that should render via <component :is>. Excludes special-cased
         * keys (overview, attendance, holidays) which have hand-written <b-tab>
         * blocks above, plus anything the API marked visible but with no
         * component name.
         */
        dynamicTabs() {
            const specialCased = ['overview', 'attendance', 'holidays'];
            return this.flatMenuItems.filter(
                item => item.show && item.component && !specialCased.includes(item.key)
            );
        },

        /**
         * Ordered list of every renderable tab (special-cased + dynamic),
         * used to compute tabIndex / keyToIndex consistently with the
         * actual <b-tab> render order in the template.
         */
        tabDefs() {
            const defs = [];
            if (this.isVisible('overview')) defs.push({ key: 'overview' });
            if (this.isVisible('holidays')) defs.push({ key: 'holidays' });
            if (this.isVisible('attendance')) defs.push({ key: 'attendance' });
            for (const tab of this.dynamicTabs) defs.push({ key: tab.key });
            return defs;
        },

        keyToIndex() {
            const map = {};
            this.tabDefs.forEach((tab, idx) => { map[tab.key] = idx; });
            return map;
        },
    },

    watch: {
        keyToIndex(newMap) {
            const idx = newMap[this.currentTabKey];
            if (idx !== undefined) {
                this.tabIndex = idx;
            }
        },
    },

    methods: {
        getAcl() {
            axios.get(this.$api_url + '/acl', {
                params: { url: this.cu }
            }).then(response => {
                this.ce = response.data;
                this.tmp_flg = true;
            });
        },

        getSettingsMenu() {
            axios.get(this.$api_url + '/settings-menu').then(response => {
                this.menu = response.data.menu || [];
            }).catch(error => {
                this.serverError ? this.serverError(error) : console.log(error);
            });
        },

        isVisible(key) {
            const item = this.flatMenuItems.find(i => i.key === key);
            return !!(item && item.show);
        },

        /**
         * Merges server-provided static props with client-only reactive
         * values that the backend can't know about (e.g. ce, which is
         * resolved asynchronously from /acl on the client).
         */
        resolveProps(tab) {
            return {
                ...(tab.props || {}),
                ce_flg: this.ce,
            };
        },

        /**
         * Generic handler for components that emit childToParent, routing
         * to the same flg-tracking fields the old per-tab handlers used.
         */
        handleChildToParent(key, value) {
            if (!value) return;
            if (value.successmsg !== undefined) this.successmsg = value.successmsg;
            if (value.warningmsg !== undefined) this.warningmsg = value.warningmsg;
            if (value.dangermsg !== undefined) this.dangermsg = value.dangermsg;

            switch (key) {
                case 'departments':
                    this.departments_flg = value.flg;
                    break;
                case 'job_positions':
                    this.jobpositions_flg = value.flg;
                    break;
                case 'work_locations':
                    this.branches_flg = value.flg;
                    break;
                case 'tax_settings':
                case 'tax_info':
                    this.taxinfo_flg = value.flg;
                    break;
            }
            this.computeCompletion();
        },

        open_item_selected(key) {
            const idx = this.keyToIndex[key];
            if (idx === undefined) {
                console.warn(`[Settings] Tab key "${key}" is not currently visible.`);
                return;
            }
            this.currentTabKey = key;
            this.tabIndex = idx;
        },

        onTabInput(idx) {
            const entry = this.tabDefs[idx];
            if (entry) {
                this.currentTabKey = entry.key;
                this.tabIndex = idx;
            }
        },

        isInGroup(groupName) {
            const entry = this.menu.find(e => e.group === groupName);
            if (!entry || !Array.isArray(entry.items)) return false;
            return entry.items.some(i => i.key === this.currentTabKey);
        },

        checkSuperUser() {
            axios.get(this.pageurl + '/user-type-level').then(response => {
                if (response.data.user_type == '1' && response.data.user_level == '1') {
                    this.supper_user = true;
                }
            });
        },

        checkServiceBookSettingsAvailable() {
            if (!this.$acl || !(this.$acl['admin-service-book/service-book-settings'] > 0)) return;

            axios.get(this.pageurl + '/admin-service-book/service-book-settings/availability')
                .then(response => {
                    this.service_book_settings_available = response.data.available !== false;
                })
                .catch(() => {});
        },

        getCompanyLeaveSettings() {
            if (!this.checkNet()) return false;

            if (this.addons.includes('LeaveAttendances')) {
                axios.get(this.pageurl + '/company/leave/settings').then(response => {
                    if (response.data.length != 0) {
                        const d = response.data;
                        this.week_holidays                   = d.week_holidays.split(',');
                        this.weekend_color_code              = d.weekend_color_code;
                        this.holiday_color_code              = d.holiday_color_code;
                        this.connect_to_payroll_calculation  = d.connect_to_payroll_calculation;
                        this.entry_time                      = d.entry_time;
                        this.allow_grace_time_late_check_in  = d.allow_grace_time_late_check_in;
                        this.grace_time_late_check_in        = d.grace_time_late_check_in;
                        this.adjust_salary_late_check_in     = d.adjust_salary_late_check_in;
                        this.days_salary_for_late_check_in   = d.days_salary_for_late_check_in;
                        this.days_late_check_in              = d.days_late_check_in;
                        this.exit_time                       = d.exit_time;
                        this.allow_grace_time_early_checkout = d.allow_grace_time_early_checkout;
                        this.grace_time_early_checkout       = d.grace_time_early_checkout;
                        this.adjust_salary_early_checkout    = d.adjust_salary_early_checkout;
                        this.allow_overtime                  = d.allow_overtime;
                        this.days_salary_for_overtime        = d.days_salary_for_overtime;
                        this.ess_punch                       = d.ess_punch;
                        this.attendance_flexibility          = d.flexible;
                        this.office_start_time               = d.office_start_time;
                        this.office_end_time                 = d.office_end_time;
                    }
                });
            } else if (this.addons.includes('Roster')) {
                axios.get(this.$api_url + '/leave-attendance/company/leave/settings').then(response => {
                    if (response.data.length != 0) {
                        const d = response.data;
                        this.roster = d.roster;
                    }
                });

                axios.get(this.$api_url + '/leave-attendance/module/settings')
                    .then(response => {
                        this.roster_access_settings = response.data.reduce((result, item) => {
                            result[item.module_key] = Number(item.value) === 1;
                            return result;
                        }, {});
                    })
                    .catch(error => {
                        this.serverError ? this.serverError(error) : console.log(error);
                    });
            }
        },

        saveSettings() {
            if (this.attendance_flexibility == 1) {
                if (!this.office_start_time || !this.office_end_time) {
                    this.$bvToast.toast('Please select valid office start time and office end time.', { title: 'Failed!', variant: 'danger', solid: true });
                    return;
                }
                if (this.office_start_time >= this.office_end_time) {
                    this.$bvToast.toast('Please select valid office start time and office end time.', { title: 'Failed!', variant: 'danger', solid: true });
                    return;
                }
            }

            let currentObj = this;
            let formData = new FormData();
            formData.append('week_holidays',                    this.week_holidays);
            formData.append('weekend_color_code',               this.weekend_color_code);
            formData.append('holiday_color_code',               this.holiday_color_code);
            formData.append('connect_to_payroll_calculation',   this.connect_to_payroll_calculation);
            formData.append('entry_time',                       this.entry_time);
            formData.append('allow_grace_time_late_check_in',   this.allow_grace_time_late_check_in);
            formData.append('grace_time_late_check_in',         this.grace_time_late_check_in);
            formData.append('adjust_salary_late_check_in',      this.adjust_salary_late_check_in);
            formData.append('days_salary_for_late_check_in',    this.days_salary_for_late_check_in);
            formData.append('days_late_check_in',               this.days_late_check_in);
            formData.append('exit_time',                        this.exit_time);
            formData.append('allow_grace_time_early_checkout',  this.allow_grace_time_early_checkout);
            formData.append('grace_time_early_checkout',        this.grace_time_early_checkout);
            formData.append('adjust_salary_early_checkout',     this.adjust_salary_early_checkout);
            formData.append('days_salary_for_early_checkout',   this.days_salary_for_early_checkout);
            formData.append('days_early_checkout',              this.days_early_checkout);
            formData.append('allow_overtime',                   this.allow_overtime);
            formData.append('days_salary_for_overtime',         this.days_salary_for_overtime);
            formData.append('ess_punch',                        this.ess_punch);
            formData.append('flexible',                         this.attendance_flexibility);
            formData.append('office_start_time',                this.office_start_time);
            formData.append('office_end_time',                  this.office_end_time);

            axios.post(this.pageurl + '/leave/settings', formData)
                .then(() => {
                    this.$bvToast.toast('Saved!', { title: 'Success', variant: 'success', solid: true });
                    location.reload();
                })
                .catch(error => currentObj.serverError(error));
        },

        checkPFEnabled() {
            let currentObj = this;
            axios.get(this.$api_url + '/ispfactive/' + this.company_id)
                .then(response => {
                    this.pf_enabled = (response.data.pf_enabled == '1') ? 1 : 0;
                })
                .catch(error => currentObj.serverError(error));
        },

        getCompanyData() {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/details').then(response => {
                if (response.data.length != 0) {
                    this.addons = response.data.module_disabled;
                    this.getCompanyLeaveSettings();
                }
            });
        },

        getOverviewFlg(value) {
            this.c_flg       += 1;
            this.overview_flg = value.flg;
            this.successmsg   = value.successmsg;
            this.warningmsg   = value.warningmsg;
            this.dangermsg    = value.dangermsg;
            this.computeCompletion();
            this.checkPFEnabled();
        },

        computeCompletion() {
            this.completion = (this.overview_flg + this.taxinfo_flg + this.departments_flg + this.jobpositions_flg + this.branches_flg) * 20;
        },
    },

    created() {
        this.getCompanyData();
        this.checkSuperUser();
        this.checkServiceBookSettingsAvailable();
        this.getSettingsMenu();
    },
};
</script>